<template>
    <!-- 公共头部 -->
    <div>
        <div class="header">
            <div class="title tipColor">{{ title }}</div>
            <div class="right" @click="onBack">
                <div class="tips">
                    {{ $t("Anniversary.tip38") }}
                    <i class="el-icon-caret-right"></i>
                </div>
                <img loading="lazy"
                    v-lazy="require('../../../assets/images/dze/close.png')"
                    class="closeimg"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    methods: {
        onBack() {
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.header {
    margin: 20px 0;
    .title {
        color: #d00;
        font-size: 14px;
        border-bottom: 2px solid #d00;
        padding: 0px 60px 20px 60px;
    }
    .right {
        cursor: pointer;
    }
    .tips {
        border: 1px solid #e0e0e0;
        border-radius: 20px;
        color: #999;
        font-size: 12px;
        padding: 5px 10px;
        display: inline-block;
        margin-right: 10px;
    }
    border-bottom: 1px solid #e8e8e8;
    .closeimg {
        width: 31px;
        height: 31px;
    }
}
</style>